import { useCallback, useRef, UIEvent } from 'react';

export const useInfinityScroll = ({
  threshold,
  load,
}: InfinityScrollOptions) => {
  const loading = useRef(false);
  const onScroll = useCallback(
    async (event: UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;

      if (
        (scrollTop + clientHeight) / scrollHeight > threshold &&
        !loading.current
      ) {
        loading.current = true;
        await load();
        loading.current = false;
      }
    },
    [load, threshold],
  );

  return { onScroll };
};

export interface InfinityScrollOptions {
  threshold: number;
  load: () => Promise<void>;
}
